import type { ChangeEventHandler, SyntheticEvent } from 'react';
import React from 'react';
import { Reference } from 'react-popper';

interface Props {
  children: React.ReactElement;
  onToggle?(e?: SyntheticEvent): void;
  onMouseOver?(e?: SyntheticEvent): void;
  onMouseLeave?(e?: SyntheticEvent): void;
}

class TooltipReference extends React.PureComponent<Props> {
  toggle: ChangeEventHandler<HTMLElement> = (e) => {
    e.stopPropagation();
    e.preventDefault();
    this.props.onToggle?.();
  };

  // TODO: refactor with `usePopper`
  render() {
    return (
      <Reference>
        {({ ref }) =>
          React.cloneElement(React.Children.only(this.props.children), {
            // @ts-expect-error // TODO: fix types
            onClick: this.toggle,
            onMouseOver: this.props.onMouseOver,
            onMouseLeave: this.props.onMouseLeave,
            ref
          })
        }
      </Reference>
    );
  }
}

export default TooltipReference;
